function toStringColombianFormat({ streetType, street, doorNumber, corner }) {
  return `${streetType} ${street}#${corner}-${doorNumber}`;
}

export default toStringColombianFormat;
